import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum InstitutionActivitySignupFields {
    ACTIVITY = 'activity',
    INSTITUTION = 'institution',
    MAIN_PRODUCT_GROSS_PRICE = 'mainProductGrossPrice',
    MAIN_PRODUCT_VAT_PERCENT = 'mainProductVatPercent',
    MAIN_PRODUCT_NET_PRICE = 'mainProductNetPrice',
    IS_OPEN = 'isOpen',
    OPEN_AT_START_OF = 'openAtStartOf',
    CLOSE_AT_END_OF = 'closeAtEndOf',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace InstitutionActivitySignupFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<InstitutionActivitySignupFields, Data> = {
        [InstitutionActivitySignupFields.ACTIVITY]: {
            text: 'Aktivität',
        },
        [InstitutionActivitySignupFields.INSTITUTION]: {
            text: 'Standort',
        },
        [InstitutionActivitySignupFields.MAIN_PRODUCT_GROSS_PRICE]: {
            text: 'Bruttopreis Hauptprodukt',
        },
        [InstitutionActivitySignupFields.MAIN_PRODUCT_VAT_PERCENT]: {
            text: 'Mehrwertsteuersatz Hauptprodukt',
        },
        [InstitutionActivitySignupFields.MAIN_PRODUCT_NET_PRICE]: {
            text: 'Nettopreis Hauptprodukt',
        },
        [InstitutionActivitySignupFields.IS_OPEN]: {
            text: 'Status',
        },
        [InstitutionActivitySignupFields.OPEN_AT_START_OF]: {
            text: 'Anmeldung möglich ab',
        },
        [InstitutionActivitySignupFields.CLOSE_AT_END_OF]: {
            text: 'Anmeldung möglich bis',
        },
        [InstitutionActivitySignupFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readOnly: true,
        },
        [InstitutionActivitySignupFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readOnly: true,
        },
    }

    export const Items = mapRecordToItems(Record);
}
